import React from 'react';
import { LibraryRowMenu } from '../../Library/LibraryDocumentMenu';

/**
 * A scenario's row menu (PRD-1701): Edit, and Archive or Unarchive, on the
 * Library's row menu, so the trigger and menu are the same Bridge controls.
 */
function ScenarioMenu({ scenario, onEdit, onArchive, onUnarchive }) {
  const actions = [
    { key: 'edit', label: 'Edit', icon: 'pencil-simple', run: onEdit },
    scenario.archived
      ? { key: 'unarchive', label: 'Unarchive', icon: 'archive', run: onUnarchive }
      : { key: 'archive', label: 'Archive', icon: 'archive', danger: true, run: onArchive },
  ];
  return <LibraryRowMenu item={scenario} actions={actions} anchorProps={{ 'data-scenario-menu': scenario.id }} />;
}

export default ScenarioMenu;
